var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xp_wrapper"},_vm._l((_vm.picks),function(p){return _c('span',{key:p.txt,staticClass:"spanbutton",class:p.cls,on:{"click":function($event){return _vm.pickme(p)}}},[_vm._v(_vm._s(p.txt))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }